"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xl = exports.lg = exports.md = exports.sm = exports.xs = void 0;
exports.xs = '0px 4px 8px rgba(0, 0, 0, 0.08)';
exports.sm = '0px 6px 12px rgba(0, 0, 0, 0.11)';
exports.md = '0px 9px 18px rgba(0, 0, 0, 0.15)';
exports.lg = '0px 13px 37px rgba(0, 0, 0, 0.21)';
exports.xl = '0px 20px 56px rgba(0, 0, 0, 0.29)';
//# sourceMappingURL=shadows.js.map